'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinTeam = exports.createTeam = exports.fetchTeam = exports.fetchTeams = exports.deserializeTeam = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var deserializeTeam = exports.deserializeTeam = function deserializeTeam(team) {
  return {
    id: team.id,
    leader: null,
    name: team.name,
    pages: team.teamMembers,
    raised: team.raisedSoFar,
    slug: team.teamShortName
  };
};

var fetchTeams = exports.fetchTeams = function fetchTeams() {
  return Promise.reject(new Error('This method is not supported for JustGiving'));
};

var fetchTeam = exports.fetchTeam = function fetchTeam() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.get)('v1/team/' + id);
};

var createTeam = exports.createTeam = function createTeam(_ref) {
  var _ref$authType = _ref.authType,
      authType = _ref$authType === undefined ? 'Basic' : _ref$authType,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? (0, _params.required)() : _ref$name,
      _ref$slug = _ref.slug,
      slug = _ref$slug === undefined ? (0, _params.required)() : _ref$slug,
      _ref$story = _ref.story,
      story = _ref$story === undefined ? (0, _params.required)() : _ref$story,
      _ref$target = _ref.target,
      target = _ref$target === undefined ? (0, _params.required)() : _ref$target,
      _ref$targetType = _ref.targetType,
      targetType = _ref$targetType === undefined ? 'Fixed' : _ref$targetType,
      _ref$teamType = _ref.teamType,
      teamType = _ref$teamType === undefined ? 'Open' : _ref$teamType,
      _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token;

  return (0, _client.put)('v1/team', {
    name: name,
    story: story,
    targetType: targetType,
    teamShortName: slug,
    teamTarget: target,
    teamType: teamType
  }, {
    headers: {
      Authorization: [authType, token].join(' ')
    }
  });
};

var joinTeam = exports.joinTeam = function joinTeam(_ref2) {
  var _ref2$authType = _ref2.authType,
      authType = _ref2$authType === undefined ? 'Basic' : _ref2$authType,
      _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _params.required)() : _ref2$id,
      _ref2$page = _ref2.page,
      page = _ref2$page === undefined ? (0, _params.required)() : _ref2$page,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token;

  return (0, _client.put)('v1/team/join/' + id, {
    pageShortName: page
  }, {
    headers: {
      Authorization: [authType, token].join(' ')
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/teams/justgiving/index.js
// module id = 1334
// module chunks = 0